<template>
    <h3
        class="text-3xl tablet-sm:text-2xl desktop:text-3xl ultra-wide:text-4xl font-semibold leading-6 font-title text-primary-text"
    >
        <slot></slot>
    </h3>
</template>
